






















































import {
  defineComponent, PropType, computed, toRefs,
} from '@nuxtjs/composition-api';
import { SfAccordion, SfTable } from '@storefront-ui/vue';
import { Product } from '~/modules/catalog/product/types';
import { getProductShippingBoxDimensions } from '~/modules/catalog/product/getters/productGetters';
import SvgImage from '~/components/General/SvgImage.vue';
import { useProductStore } from '~/modules/catalog/stores/product';

export default defineComponent({
  components: {
    SfAccordion,
    SfTable,
    SvgImage,
  },
  props: {
    product: {
      type: [Object, null] as PropType<Product | null>,
      default: null,
    },
    tab: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const { lastOpenedTabId, resetLastOpenedTabId } = toRefs(useProductStore());

    const safeJsonParse = (s?: string): any | null => {
      try {
        return JSON.parse(s);
      } catch (e) {
        console.error('JSON parse error:', e.message);
        return null;
      }
    };

    const boxes = computed(() => safeJsonParse(getProductShippingBoxDimensions(props.product)));

    return {
      lastOpenedTabId,
      resetLastOpenedTabId,
      boxes,
      getProductShippingBoxDimensions,
    };
  },
});
